// dependencies
import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

// components
import Button from "@cloudspire/legacy-resources/src/components/Button2";

// contexts
import { useRouters } from "../../../contexts/routers";
import { useConfiguration } from "../../../contexts/configuration";

// helpers
import bookingGetCreateUrl from "../../../helpers/booking/getCreateUrl";

function ReserveButtonContainer(props) {
  const { parameterList, aStyle, onPressBooking, room } = props;

  const { bookingRouter } = useRouters();

  const intl = useIntl();

  const configuration = useConfiguration();

  return (
    <Button
      aStyle={aStyle}
      to={bookingGetCreateUrl({
        parameterList,
        bookingRouter,
        configuration,
        locale: intl.locale,
        room,
      })}
      appearance="primary"
      label={intl.formatMessage({
        defaultMessage: "Réserver en ligne",
      })}
      data-gtm="room-aside-book"
      onPress={onPressBooking}
    />
  );
}

ReserveButtonContainer.propTypes = {
  parameterList: PropTypes.object,
  onPressBooking: PropTypes.func,
  aStyle: PropTypes.object,
};

export default ReserveButtonContainer;
